import React from 'react';
import i18n from './i18n';
import "./components/language_switcher.css";

export const LanguageSwitcher = () => {
 

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switch">
      <button onClick={() => changeLanguage('en')} className="language-button">En</button>
      <button onClick={() => changeLanguage('zh')} className="language-button">中文</button>
    </div>
  );
};

